import * as React from 'react'
import { useSpring, animated } from '@react-spring/web'

const ImageSlider = ({ images }) => {
  const [activeIndex, setActiveIndex] = React.useState(0)
  const lastIndex = React.useRef(0)

  React.useEffect(() => {
    const interval = setInterval(() => {
      lastIndex.current = activeIndex
      setActiveIndex(i => (i + 1) % images.length)
    }, 5000)
    return () => clearInterval(interval)
  }, [activeIndex, images.length])

  return (
    <div className="w-full h-full relative overflow-hidden">
      {images.map((image, index) => (
        <AnimatedImage
          key={index}
          index={index}
          activeIndex={activeIndex}
          lastActiveIndex={lastIndex.current}
          image={image}
        />
      ))}
    </div>
  )
}

const AnimatedImage = ({ index, activeIndex, image, lastActiveIndex }) => {
  const [props] = useSpring(() => {
    if (index === activeIndex) {
      return {
        from: { x: '100%' },
        to: { x: '0%' },
      }
    } else if (index === lastActiveIndex) {
      return {
        from: { x: '0%' },
        to: { x: '-100%' },
      }
    } else {
      return {
        from: { x: '100%' },
        to: { x: '100%' },
      }
    }
  }, [index, activeIndex, lastActiveIndex])
  return (
    <animated.div
      className="absolute inset-0 overflow-hidden flex flex-row items-center justify-center"
      style={{
        zIndex: index === activeIndex ? 2 : index === lastActiveIndex ? 1 : 0,
        opacity: index === activeIndex || index === lastActiveIndex ? 1 : 0,
        ...props,
      }}
    >
      <img
        src={image.url}
        alt={image.title}
        className="object-contain max-w-full max-h-full"
      />
    </animated.div>
  )
}

export default ImageSlider
